export default __webpack_public_path__ + "static/ukzn-tl-cover-1-1114044e1bd1b1d5f030c70f8d3a8878.jpg";